enum ExceptionTypes {
  NfcCodeExistsException = "NfcCodeExistsException",
  MultipleCheckOutException = "MultipleCheckOutException",
}

export default ExceptionTypes;
